import React, { useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

// component
import { useIntl } from "react-intl";
import ButtonMain from "../../../../../../../../../common/components/button/ButtonMain";
import MsgDialog from "../../../../../../../../../common/components/dialog/MsgDialog";

// utils
import Act from "../../../../../../../../../store/actions";
import { isEmpty } from "../../../../../../../../../common/utils";
import { StoreContext } from "../../../../../../../../../store/StoreProvider";
import ApiUrls from "../../../../../../../../../api/project/ApiUrls";
import { generateOcrResultApi } from "./ocrHelper";
import {
  OCR_CONTENT,
  OCR_ERROR_MSG,
  OCR_FOLDER_NAME,
  OCR_RESULT_STATUS,
  OCR_STATUS,
} from "../../../../Config";

// image
import checkedImg from "../../../../../../../../../../images/ocr_image/ocr_no_checked.svg";
import NoQuota from "../../../../component/NoQuota";

const OcrButton = () => {
  const [state, dispatch] = useContext(StoreContext);
  const { digitalAI, user, sna } = state;
  const { ocrImgList, ocrStatus, ocrOriginalData } = digitalAI;
  const { quota } = sna;
  const [open, setOpen] = useState(false);

  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  const totalOcrImg = useMemo(
    () => ocrImgList.filter((el) => el.checked).length,
    [ocrImgList]
  );

  // const completeOcrImg = useMemo(
  //   () => ocrImgList.filter((el) => OCR_CONTENT in el).length,
  //   [ocrImgList]
  // );

  const ocrText = useMemo(() => {
    if (isEmpty(ocrImgList)) {
      return intl.formatMessage({
        id: "sna.sidetool.digitalAITool.ocr.generate",
        defaultMessage: "產生 OCR",
      });
    }

    if (ocrStatus) {
      return intl.formatMessage({
        id: "sna.sidetool.digitalAITool.ocr.generate.loading",
        defaultMessage: "OCR產生中，請稍候...",
      });
    }
    // if (completeOcrImg) {
    //   return `完成 ${completeOcrImg} 張，已選取 ${totalOcrImg} 張檔案產生OCR`;
    // }

    return intl.formatMessage(
      {
        id: "sna.sidetool.digitalAITool.ocr.generate.select",
        defaultMessage: "已選取 {totalOcrImg} 張檔案產生OCR",
      },
      {
        totalOcrImg,
      }
    );
  }, [totalOcrImg, ocrStatus]);

  const fetchDataFromDB = async ({ userId, folderName }) => {
    const apiUrl = ApiUrls.getOcrImgList
      .replace("{limit}", -1)
      .replace("{offset}", 0)
      .replace("{filename}", folderName)
      .replace("{userId}", userId);

    await axios
      .get(apiUrl)
      .then((res) => {
        const { data } = res.data;

        const updateImgList = ocrImgList.map((imgObj) => {
          const { checked, hasOcr } = imgObj;

          if (OCR_CONTENT in imgObj) {
            return imgObj;
          }

          if (!checked) return imgObj;

          const tmpData = data.find((item) => item.hasOcr === hasOcr);

          if (OCR_CONTENT in tmpData) {
            if (tmpData[OCR_CONTENT] === OCR_ERROR_MSG) {
              return {
                ...imgObj,
                [OCR_RESULT_STATUS]: false,
                [OCR_CONTENT]: OCR_ERROR_MSG,
              };
            }
            return {
              ...imgObj,
              [OCR_RESULT_STATUS]: true,
              [OCR_CONTENT]: tmpData[OCR_CONTENT],
            };
          }

          return imgObj;
        });

        const updateOriginalData = ocrOriginalData.map((imgObj) => {
          const { hasOcr } = imgObj;

          const tmpData = data.find((item) => item.hasOcr === hasOcr);

          if (OCR_CONTENT in tmpData) {
            return {
              ...imgObj,
              [OCR_CONTENT]: tmpData[OCR_CONTENT],
            };
          }

          return imgObj;
        });

        const firstOcr = updateImgList.findIndex(
          (el) =>
            el.imgUrl ===
            updateImgList.find((first) => OCR_CONTENT in first).imgUrl
        );

        // 自動跳到 OCR 結果的第一張圖片
        // setFocusItem(newImgList[firstOcr]);

        dispatch({
          type: Act.DIGITAL_OCR_ERROR_COUNT,
          payload:
            updateImgList.filter(
              (el) => OCR_RESULT_STATUS in el && !el[OCR_RESULT_STATUS]
            ).length || null,
        });

        dispatch({
          type: Act.DIGITAL_AI_SET_ACTIVE_PAGE,
          payload: firstOcr,
        });

        dispatch({
          type: Act.DIGITAL_AI_SET_IMG_LIST,
          payload: updateImgList,
        });

        dispatch({
          type: Act.SNA_SET_OCR_ORIGINAL_DATA,
          payload: updateOriginalData,
        });

        // 結束loading
        dispatch({
          type: Act.DIGITAL_AI_SET_OCR_STATUS,
          payload: false,
        });

        // finish
        dispatch({
          type: Act.DIGITAL_AI_SET_OCR_FINISH,
          payload: true,
        });

        localStorage.setItem(OCR_STATUS, JSON.stringify(false));
      })
      .catch((err) => console.error(`Failed to fetch data from DB: ${err}`));
  };
  //
  const checkProcessingStatus = async ({ userId, folderName }) => {
    try {
      const response = await axios.post(ApiUrls.checkOcrResult, {
        username: userId,
      });
      if (response.status === 200) {
        await fetchDataFromDB({ userId, folderName });
      } else if (response.status === 201) {
        // 如果處理還未完成，則間隔五秒後做下一次檢查
        setTimeout(async () => {
          await checkProcessingStatus({ userId, folderName });
        }, 5 * 1000);
      } else {
        localStorage.setItem(OCR_STATUS, JSON.stringify(false));

        dispatch({
          type: Act.DIGITAL_AI_SET_OCR_STATUS,
          payload: false,
        });
      }
    } catch (error) {
      dispatch({
        type: Act.DIGITAL_AI_SET_OCR_STATUS,
        payload: false,
      });
      localStorage.setItem(OCR_STATUS, JSON.stringify(false));
    }
  };

  const handleOcr = () => {
    // 如果額度已滿，阻擋使用者
    if (quota.ocr === true) {
      setIsOpen(true);
      return;
    }

    generateOcrResultApi({
      user,
      ocrFile: ocrImgList,
      onUploadLoading: (status) => {
        dispatch({
          type: Act.DIGITAL_AI_SET_OCR_STATUS,
          payload: status,
        });
        localStorage.setItem(OCR_STATUS, JSON.stringify(status));
      },
      onSuccess: checkProcessingStatus,
      onError: ({ message }) => {
        console.log(message);
      },
    });
  };

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    const checkStatus = localStorage.getItem(OCR_STATUS);

    if (checkStatus === "true") {
      const checkFolderName = localStorage.getItem(OCR_FOLDER_NAME);
      if (checkFolderName) {
        dispatch({
          type: Act.DIGITAL_AI_SET_OCR_STATUS,
          payload: Boolean(checkStatus),
        });

        checkProcessingStatus({
          userId: user.uid,
          folderName: checkFolderName,
        });
      }
    } else {
      dispatch({
        type: Act.DIGITAL_AI_SET_OCR_STATUS,
        payload: false,
      });
    }
  }, []);

  return (
    <>
      <ButtonMain
        buttonProps={{
          sx: { borderRadius: "6px" },
          onClick: ocrImgList.some((el) => el.checked) ? handleOcr : handleOpen,
          text: ocrText,
          fullWidth: true,
          disabled:
            isEmpty(ocrImgList) ||
            ocrStatus ||
            ocrImgList.every((el) => OCR_CONTENT in el),
          variant:
            isEmpty(ocrImgList) ||
            ocrStatus ||
            ocrImgList.every((el) => OCR_CONTENT in el)
              ? "disableLinearGradient"
              : "linearGradient",
        }}
      />
      <MsgDialog
        setOpen={setOpen}
        open={open}
        src={checkedImg}
        alt="checkedImg"
        dialogTitleText={intl.formatMessage({
          id: "sna.sidetool.digitalAITool.ocr.need.check",
          defaultMessage: "請先勾選欲OCR的檔案",
        })}
      />
      <NoQuota isOpen={isOpen} closeFct={closeModal} />
    </>
  );
};

export default OcrButton;
